import { eFeeType } from './eFeeType';
import { eSSSection } from '../../../ui-toolkit/settlementStatement/eSSSection';
import { eSectionType } from '../../order/escrow/ISettlementStatement';

export interface IRefinanceAPIFeeResponse {
  type: eFeeType;
  label: string;
  amount: number;
  buyer_total?: number;
  paid_by_others_total?: number;
  section: eSectionType;
  ss_section: eSSSection;
  ss_label: string;
  buyer_at_closing?: number;
  buyer_before_closing?: number;
  seller_at_closing?: number;
  seller_before_closing?: number;
  ss_fee_order: number;
}

export interface IRefinanceAPIFeeData {
  type: eFeeType;
  label: string;
  amount: number;
  buyerTotal?: number;
  paidByOthersTotal?: number;
  section: eSectionType;
  ssSection: eSSSection;
  ssLabel: string;
  buyerAtClosing?: number;
  buyerBeforeClosing?: number;
  sellerAtClosing?: number;
  sellerBeforeClosing?: number;
  ssFeeOrder: number;
}

export const convertIRefinanceAPIFeeResponseToIRefinanceAPIFeeData = ({
  buyer_total,
  paid_by_others_total,
  ss_section,
  ss_label,
  buyer_at_closing,
  buyer_before_closing,
  seller_at_closing,
  seller_before_closing,
  ss_fee_order,
  ...rest
}: IRefinanceAPIFeeResponse): IRefinanceAPIFeeData => ({
  buyerTotal: buyer_total,
  paidByOthersTotal: paid_by_others_total,
  ssSection: ss_section,
  ssLabel: ss_label,
  buyerAtClosing: buyer_at_closing,
  buyerBeforeClosing: buyer_before_closing,
  sellerAtClosing: seller_at_closing,
  sellerBeforeClosing: seller_before_closing,
  ssFeeOrder: ss_fee_order,
  ...rest,
});

export const convertIRefinanceAPIFeeDataToIRefinanceAPIFeeResponse = ({
  buyerTotal,
  paidByOthersTotal,
  ssSection,
  ssLabel,
  buyerAtClosing,
  buyerBeforeClosing,
  sellerAtClosing,
  sellerBeforeClosing,
  ssFeeOrder,
  ...rest
}: IRefinanceAPIFeeData): IRefinanceAPIFeeResponse => ({
  buyer_total: buyerTotal,
  paid_by_others_total: paidByOthersTotal,
  ss_section: ssSection,
  ss_label: ssLabel,
  buyer_at_closing: buyerAtClosing,
  buyer_before_closing: buyerBeforeClosing,
  seller_at_closing: sellerAtClosing,
  seller_before_closing: sellerBeforeClosing,
  ss_fee_order: ssFeeOrder,
  ...rest,
});
